
import _ from 'lodash';
import React from 'react';

import Expandable from 'components/global/application/Expandable';
import BrandInfoModelLink from 'components/pages/brand/BrandInfoModelLink';
import { BrandInfoModels } from 'types/drupal/BrandInfo';

interface Props {
    brand: string;
    brandModels: BrandInfoModels[];
    year: string;
}

interface State {
    expanded: boolean;
}
class BrandInfoModelLinksMobile extends React.Component<Props, State> {
    public constructor(props: any) {
        super(props);
        this.state = { expanded: false };
    }

    public showOptionsToggle = () => {
        this.setState({ expanded: !this.state.expanded });
    }

    public render() {
        return (
            <div className="col-10 offset-1">
                <div className="InventoryFilter-container-mobile Select Select--single Filter-options-dropdown"  onClick={this.showOptionsToggle}>
                    <div className="Select-look-alike">
                        Models
                        <span className="">
                            <span className="Select-arrow Select-arrow-lookalike" />
                        </span>
                    </div>
                    <Expandable className="InventoryFilterOptions-container-mobile" expanded={this.state.expanded} direction="vertical" maxHeight="860px">
                        <div className="PadBottom-container">
                            {_.map(this.props.brandModels, (brandModel)  => {
                                return (<BrandInfoModelLink key={brandModel.slug} brand={this.props.brand} brandModel={brandModel} year={this.props.year} isMobile={true} />);
                            })
                            }
                        </div>
                    </Expandable>
                </div>
            </div>
        );
    }
}

export default BrandInfoModelLinksMobile;



// WEBPACK FOOTER //
// ./src/components/pages/brand/BrandInfoModelLinksMobile.tsx